import { useEffect, useState } from "react";
const useCourses = () => {
  const [courses, setCourses] = useState([]);

  // console.log("tui to kaj kor")

  useEffect(() => {
    //   fetching fake data
    fetch("./fakedata.JSON")
      .then((res) => res.json())
      .then((data) => {
        setCourses(data.courses);
      });
  }, []);
  return [courses, setCourses];
};
export default useCourses;